import React from "react";
import { useSettings } from "@/lib/settings";
import { buildWhatsAppUrl, generalWhatsAppMessage } from "@/lib/api";
import { useUIOverlay } from "@/lib/uiOverlay";

export default function FloatingWhatsApp() {
  const { settings } = useSettings();
  const { menuOpen, primaryCtaVisible } = useUIOverlay();
  const wa = settings?.whatsapp;
  if (!wa) return null;
  // Hide when it would collide with the mobile menu or with the product
  // page's on-screen primary CTA. Use opacity+pointer-events so re-appear
  // is smooth and the DOM node stays stable.
  const hidden = menuOpen || primaryCtaVisible;
  return (
    <a
      href={buildWhatsAppUrl(wa, generalWhatsAppMessage())}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-5 right-5 z-40 bg-[#22C55E] hover:bg-[#16A34A] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-2xl wa-pulse transition-opacity duration-200 ${hidden ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      data-testid="floating-whatsapp"
      aria-hidden={hidden}
      aria-label="Hubungi via WhatsApp"
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.966-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.05 2.5C6.784 2.5 2.5 6.784 2.5 12.05c0 1.797.507 3.548 1.464 5.058L2.5 21.5l4.517-1.436a9.487 9.487 0 0 0 5.033 1.436c5.266 0 9.55-4.284 9.55-9.55S17.316 2.5 12.05 2.5z"/></svg>
    </a>
  );
}
